export const FLOWS = {
  creation: 'creation',
  evolution: 'evolution',
  promotion: 'promotion',
  fix: 'fix',
}
